import Vue from 'vue';
import { store, Module } from 'etadmin-common';
import Store from './config.store';
import { Toast } from 'vant';
/** constant */
const CONST = {
  USER: {
    TOKEN: 'USER_TOKEN_H5'
  }
};
// app内
export function isRmtEnv() {
  return window.navigator.userAgent.indexOf('Rmt') > -1;
}
// 开发环境
export function isDevEnv() {
  return process.env.NODE_ENV === 'development';
}
// 微信内
export function isWeiXinEnv() {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  } else {
    return false;
  }
}

// 是否登录
export function isLogin() {
  return Promise.resolve($$.token.get()).then((token) => {
    if (token) {
      return true;
    } else {
      return Promise.reject(false);
    }
  });
}

/** token */
const token = {
  get() {
    // App(Rmt)
    if (isRmtEnv()) {
      return new Promise((resolve) => {
        rmt
          ? rmt.getToken({
              success: function(data) {
                if (data && data.token && data.token !== 'token') {
                  resolve(data.token);
                } else {
                  resolve('');
                }
                console.log('getToken success');
              },
              fail: function() {
                console.log('getToken fail');
                resolve('');
              }
            })
          : resolve('');
      });
    }
    // Web
    else {
      return store.get(CONST.USER.TOKEN);
    }
  },
  set(token) {
    store.set(CONST.USER.TOKEN, token);
  }
};

/** 校验房间密码 */
function toAuth(id, roomPass) {
  return new Promise((resolve, reject) => {
    $$.module.core.$api.room({
      data: { roomId: id, roomPass },
      success: (data) => {
        resolve(data);
      },
      exception: (exception) => {
        reject(exception.msg);
      }
    });
  });
}

function setAuth(roomId, data) {
  localStorage.setItem(roomId, JSON.stringify(data));
}
function getAuth(roomId) {
  return JSON.parse(localStorage.getItem(roomId)) || {};
}

export function getRoomShareViewAuth() {
  let auth = $$.module.data.room.roomSettingContent.roomAuth.roomAuthThree;
  return {
    onlyView: auth == '0',
    disableView: auth == '1',
    enableLogin: auth == '2'
  };
}

/** 输入观看密码界面 */
function popCodeAuth(userinfo, room) {
  return new Promise((resolve) => {
    $$.module.RenderComponent('CodeEnter', {
      props: { value: true, data: room.roomSystemInfo },
      on: {
        submit: ({ code, close }) => {
          toAuth(room.roomId, code).then((res) => {
            if (res.roomSettingContent.roomAuth.auth) {
              $$.module.data.room = res;
              setAuth(room.roomId, { code, userId: userinfo.id, auth: true });
              close();
              resolve(true);
            } else {
              setAuth(room.roomId, { auth: false });
              $$.vue.$toast('密码错误');
            }
          });
        }
      }
    });
  });
}
/** 登陆界面 */
function popLogin(enableClose) {
  return new Promise((resolve) => {
    $$.module.RenderComponent('Login', {
      props: { value: true, overlayClose: !!enableClose },
      on: {
        success: (data) => {
          $$.token.set(data.token);
          resolve(data);
        }
      }
    });
  });
}

/** 直播间观看权限拦截器 */
function authIntercept(auth) {
  const { userinfo, room } = $$.module.data;
  return new Promise((resolve) => {
    switch (auth) {
      case '0':
        resolve(true);
        break;
      case '1':
        if (userinfo.auth === 1) {
          resolve(true);
        } else {
          toLogin(() => {
            // location.reload();
            location.href += `&t=${new Date().getTime()}`;
          });
        }
        break;
      case '2':
        if (getAuth(room.roomId).auth) {
          toAuth(room.roomId, getAuth(room.roomId).code).then((res) => {
            if (res.roomSettingContent.roomAuth.auth) {
              resolve(true);
            } else {
              popCodeAuth(userinfo, room).then((res) => {
                res && resolve(true);
              });
            }
          });
        } else {
          popCodeAuth(userinfo, room).then((res) => {
            res && resolve(true);
          });
        }

        break;
      case '3':
        resolve(true);
        break;
      default:
        resolve(false);
        break;
    }
  });
}

/** 获取观看权限 */
function getRoomAuth() {
  return new Promise((resolve) => {
    $$.module.core.$api.getRoomAuth({
      data: { roomId: $$.module.data.room.roomId },
      success: (res) => {
        console.log('getRoomAuth', res);
        resolve(res);
      }
    });
  });
}

/** 打开app或者打开下载页 */
export function openAppOrDownApp({ fail } = {}) {
  if (isWeiXinEnv()) {
    Store.commit('WX_SHOW_TIP_LAYER', true);
    // $$.vue.$toast('点击右上角从浏览器打开');
    return;
  }

  const roomSystemInfo = $$.module.data.room.roomSystemInfo || {};
  if (roomSystemInfo.appProtocolOne) {
    // 将所有 loading Toast 设置为背景不可点击
    // Toast.setDefaultOptions('loading', { forbidClick: true });
    Toast.loading('', { forbidClick: true, duration: 0 });
    // 唤起app
    window.location.href = roomSystemInfo.appProtocolOne;
    setTimeout(() => {
      let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden;
      console.log('hidden', hidden);
      if (typeof hidden == 'undefined' || hidden == false) {
        // App store下载地址
        window.location.href = roomSystemInfo.appDownloadUrl;
      }
      Toast.clear();
    }, 3000);
  } else if (roomSystemInfo.appDownloadUrl) {
    // App store下载地址
    window.location.href = roomSystemInfo.appDownloadUrl;
  } else {
    fail?.();
  }
}

/** 需不需要打开app的ui */
export function needOpenApp() {
  const roomSystemInfo = $$.module.data.room.roomSystemInfo || {};
  return !isRmtEnv() && (roomSystemInfo.appProtocolOne || roomSystemInfo.appDownloadUrl) && !getRoomShareViewAuth().enableLogin;
}

/** 需要打开app和登陆回掉拦截器  */
export function openAppAndLoginInterceptor(callback, { requireLogin = true, loginAfterReload = true } = {}) {
  if (needOpenApp()) {
    openAppOrDownApp();
  } else {
    if (requireLogin) {
      loginDoSomething(callback, loginAfterReload);
    } else {
      callback?.();
    }
  }
}
/** 需要登陆 */
export function loginDoSomething(callback, loginAfterReload) {
  if (!isRmtEnv() && !getRoomShareViewAuth().enableLogin) {
    return;
  }

  Promise.resolve($$.token.get()).then((token) => {
    if (token) {
      callback?.();
    } else {
      toLogin(() => {
        if (loginAfterReload) {
          // window.location.reload();
          location.href += `&t=${new Date().getTime()}`;
        } else {
          callback?.(true);
        }
      }, true);
    }
  });
}

/** 去登陆 */
export function toLogin(callback = () => {}, enableClose = false) {
  // 端内登录
  if (isRmtEnv()) {
    rmt.openLogin({
      success: function() {
        callback();
      }
    });
  }
  // console.log(enableClose);
  // 端外登录
  else {
    popLogin(enableClose).then(() => {
      callback();
    });
  }
}

// 路由
const interceptPaths = ['interview/teaser', 'interview/home'];
const route = {
  login(url = 'core/common/login') {
    route.push(url);
  },
  message(message, url = 'core/common/message') {
    $$.module.data.message = message;
    route.push(url);
  },
  async push(url) {
    if (interceptPaths.includes(url)) {
      const roomAuth = await getRoomAuth();
      let { roomAuthOne, roomAuthTwo } = roomAuth;
      if (roomAuthOne === '0' && roomAuthTwo === '0') {
        $$.module.route.push(url);
        return;
      }
      if (roomAuthOne === '2') {
        // 交换变量值使密码验证最后进行
        [roomAuthOne, roomAuthTwo] = [roomAuthTwo, roomAuthOne];
      }
      // 0无权限 1注册用户 2密码观看 3白名单
      let next = await authIntercept(roomAuthOne);
      if (next) {
        next = await authIntercept(roomAuthTwo);
        next && $$.module.route.push(url);
      }
    } else {
      $$.module.route.push(url);
    }
  }
};

const loginInterceptPath = [
  // '/api/memberPraise/addPraise',
  '/api/memberReservation/addReservation',
  '/api/room/interview/chat/sendMemberChatMsg',
  '/api/room/interview/chat/sendQuestionMsg'
];
/** 登陆拦截器 */
function loginIntercept(config) {
  return new Promise((resolve, reject) => {
    if (loginInterceptPath.includes(config.url)) {
      Promise.resolve($$.token.get()).then((token) => {
        if (!token) {
          reject();
          toLogin(() => {
            location.reload();
          }, true);
        } else {
          resolve(config);
        }
      });
    } else {
      resolve(config);
    }
  });
}
function loading(display, sleep = 0) {
  setTimeout(() => {
    const loading = document.getElementById('loading');
    loading && (loading.style.display = display ? '' : 'none');
  }, sleep);
}
/** module */
const http = {
  baseURL: '/stream-port',
  method: 'post',
  token: false,
  request(config) {
    let promise = loginIntercept(config);
    // token
    if (config.token) {
      promise = promise
        .then((config) => {
          // token
          return Promise.resolve($$.token.get()).then((token) => {
            token && (config.headers['token'] = token);
            return config;
          });
        })
        .catch((error) => {
          // $$.router.login()
          throw error;
        });
    }

    // intercept request
    if (config.intercept && config.intercept.request) {
      promise = promise.then((config) => {
        return config.intercept.request(config);
      });
    }

    return promise.then((config) => {
      return config;
    });
  },
  response(response) {
    const config = response.config;
    let promise = Promise.resolve(response);

    // intercept response
    if (config.intercept && config.intercept.response) {
      promise = promise.then((response) => {
        return config.intercept.response(response);
      });
    }

    return promise.then((response) => {
      const data = response.data;
      switch (data.code) {
        // success
        case 0:
          config.success && config.success(data.data);
          break;
        case 1:
          if (!$$.vue || !$$.vue.$toast) {
            loading(false);
            $$.route.message(data.msg);
          } else {
            $$.vue.$toast(data.msg);
          }
          config.exception(data);
          break;
        // other
        default:
          config.exception(data);
      }

      return response;
    });
  },
  exception(exception) {
    console.error(exception.msg);
    // alert(exception.msg);
  },
  error(error) {
    console.error('未处理错误', error);
  }
};

const compile = {};

$$.mixin({
  production: process.env.NODE_ENV === 'production' && process.env.VUE_APP_PREVIEW !== 'true',
  publicPath: process.env.BASE_URL,
  CONST,
  token,
  route
});

$$.module = new Module({ name: 'root', data: { route: [''] }, menu: [], config: { http, compile } });
// $$.module = new Module({ name: 'root', data: { route: ['core/common/loading'] }, menu: [], config: { http, compile } });
// core module
const core = require('@/views/core/index').default;
$$.module.compile(core);

const config = () => {
  // modules
  $$.module.set({
    modules: {
      interview: () => import(/* webpackChunkName: "tpl_interview" */ '@/template/interview/index'),
      anchor: () => import(/* webpackChunkName: "tpl_anchor" */ '@/template/anchor/index'),
      test: () => import(/* webpackChunkName: "tpl_test" */ '@/template/test/index')
    }
  });

  // start(vue)
  return {
    mount: (app = '#root') => {
      const vue = require('./config.vue').default;
      vue.init(app);
    }
  };
};

export default {
  ...$$,
  config
};

// open
$$.module.open = function open(open) {
  const { name, props } = open;
  if (!name) {
    throw 'name is null';
  }
  const component = typeof name === 'function' ? name() : name.install();
  $$.module.RenderComponent(component, props);
};

// extends $$
$$.module.RenderComponent = function RenderComponent(component, props) {
  Promise.resolve(component).then((comp) => {
    const RenderComponent = Vue.extend({
      name: 'RenderComponent',
      render() {
        return <comp {...{ ...props }} />;
      }
    });

    (document.getElementById('root') || document.body).appendChild(new RenderComponent().$mount().$el);
  });
};
